/**
 * List Schema of AuditoriaMotivo
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {AuditoriaMotivo} from '@/model/resource/AuditoriaMotivo'

export class ListAuditoriaMotivoSchema extends Schema {
  readonly name = 'ListAuditoriaMotivo'

  readonly fieldSet: FieldSet<AuditoriaMotivo> = {
    idMotivoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
